import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpEventType,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';
import { environment } from 'src/environments/environment';
import { UserData } from '../userData';
import SessionExpiry from '../sessionExpiry';
import { tap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    AUTH_SERVER_ADDRESS: string;

    constructor(
        private authService: AuthService,
        private userData: UserData,
        private sessionExpiry: SessionExpiry,
    ) {
        this.AUTH_SERVER_ADDRESS = environment.apiUrl;
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const accessToken = localStorage.getItem('digimaker/programming/user')
            ? JSON.parse(localStorage.getItem('digimaker/programming/user'))?.accessToken
            : null;

        if (!request.url.includes('login')) {
            this.sessionExpiry.updateAuthTokenExpiry();
        }

        const authRequest = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${accessToken}`),
        });

        return next.handle(authRequest).pipe(
            tap((event) => {
                if (event.type === HttpEventType.Response) {
                }
            }),
        );
    }
}
